import { Header } from '@/components/Header';
import { Footer } from '@/components/Footer';
import { SEOHead } from '@/components/SEOHead';

export const CGVPage = () => {
  return (
    <div className="min-h-screen bg-background">
      <SEOHead 
        title="Conditions Générales de Vente | Homely Solutions"
        description="Conditions Générales de Vente de Homely Solutions Sàrl pour les services de nettoyage, conciergerie, rénovation et autres prestations."
      />
      
      <Header />
      
      <main className="py-20">
        <div className="mx-auto w-full max-w-[var(--container)] px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl font-bold mb-8" style={{ fontFamily: 'var(--font-heading)' }}>
            Conditions Générales de Vente
          </h1>
          
          <p className="text-lg text-muted-foreground mb-8">
            Dernière mise à jour : Mars 2026
          </p>
          
          <div className="prose prose-lg max-w-none">
            <section className="mb-12">
              <h2 className="text-2xl font-semibold mb-4">Article 1 - Objet et champ d'application</h2>
              <p>
                Les présentes Conditions Générales de Vente (ci-après "CGV") régissent les relations contractuelles 
                entre Homely Solutions Sàrl (ci-après "Homely Solutions" ou "le Prestataire") et tout client 
                (ci-après "le Client") faisant appel à ses services.
              </p>
              <div className="bg-gray-50 p-6 rounded-lg mt-4">
                <p><strong>Homely Solutions Sàrl</strong></p>
                <p>Rue Jean-André Venel 4</p>
                <p>1400 Yverdon-les-Bains</p>
                <p>Suisse</p>
                <p className="mt-4"><strong>Email :</strong> contact@homely-solutions.ch</p>
              </div>
              <p className="mt-4">
                Ces CGV s'appliquent à l'ensemble des prestations proposées par Homely Solutions, notamment :
              </p>
              <ul>
                <li>Services de nettoyage professionnel</li>
                <li>Conciergerie et gestion locative (Airbnb, location courte durée)</li>
                <li>Rénovation intérieure (cuisine, salle de bain, rénovation complète)</li>
                <li>Montage de meubles et services de bricolage</li>
                <li>Services marketing et de valorisation immobilière</li>
                <li>Accompagnement à la vente immobilière</li>
              </ul>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl font-semibold mb-4">Article 2 - Devis et commande</h2>
              <h3 className="text-xl font-medium mt-6 mb-3">2.1 Demande de devis</h3>
              <p>
                Toute prestation fait l'objet d'un devis préalable gratuit et sans engagement. Le devis détaille :
              </p>
              <ul>
                <li>La nature des prestations</li>
                <li>Le prix hors taxes et toutes taxes comprises</li>
                <li>Les délais d'exécution estimés</li>
                <li>Les conditions de paiement</li>
                <li>La durée de validité du devis (30 jours sauf mention contraire)</li>
              </ul>
              
              <h3 className="text-xl font-medium mt-6 mb-3">2.2 Acceptation et commande</h3>
              <p>
                Le devis signé par le Client vaut commande ferme. La signature du devis implique l'acceptation 
                intégrale et sans réserve des présentes CGV.
              </p>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl font-semibold mb-4">Article 3 - Prix et paiement</h2>
              <h3 className="text-xl font-medium mt-6 mb-3">3.1 Prix</h3>
              <p>
                Les prix sont indiqués en francs suisses (CHF) et s'entendent hors taxes (HT) et toutes taxes 
                comprises (TTC). La TVA applicable est celle en vigueur au moment de la facturation.
              </p>
              <p>
                Les prix peuvent être révisés en cas de modification significative du périmètre des travaux 
                ou de découverte d'éléments non visibles lors de l'établissement du devis initial.
              </p>

              <h3 className="text-xl font-medium mt-6 mb-3">3.2 Modalités de paiement</h3>
              <p>Sauf accord contraire mentionné au devis :</p>
              <ul>
                <li><strong>Prestations ponctuelles</strong> (nettoyage, montage) : paiement intégral à la fin de la prestation</li>
                <li><strong>Travaux de rénovation</strong> : 
                  <ul>
                    <li>30% à la commande</li>
                    <li>40% en cours de travaux</li>
                    <li>30% à la réception des travaux</li>
                  </ul>
                </li>
                <li><strong>Conciergerie</strong> : facturation mensuelle, paiement à 30 jours</li>
              </ul>
              <p className="mt-4">
                Moyens de paiement acceptés : virement bancaire, TWINT, carte de crédit (selon prestation).
              </p>

              <h3 className="text-xl font-medium mt-6 mb-3">3.3 Retard de paiement</h3>
              <p>
                En cas de retard de paiement, des intérêts moratoires au taux de 5% l'an seront appliqués 
                de plein droit, sans mise en demeure préalable. Des frais de rappel de CHF 20.- par rappel 
                pourront également être facturés.
              </p>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl font-semibold mb-4">Article 4 - Exécution des prestations</h2>
              <h3 className="text-xl font-medium mt-6 mb-3">4.1 Délais</h3>
              <p>
                Les délais indiqués sont donnés à titre indicatif. Homely Solutions s'engage à respecter 
                les délais convenus dans la mesure du possible. En cas de retard significatif (supérieur à 
                15 jours ouvrables), le Client sera informé dans les meilleurs délais.
              </p>
              <p>
                Les retards ne peuvent donner lieu à indemnisation sauf faute grave du Prestataire.
              </p>

              <h3 className="text-xl font-medium mt-6 mb-3">4.2 Accès aux locaux</h3>
              <p>
                Le Client s'engage à fournir un accès aux locaux aux dates et heures convenues. 
                Tout retard ou absence du Client entraînant l'impossibilité d'intervenir pourra donner lieu 
                à une facturation de frais de déplacement (minimum CHF 50.-).
              </p>

              <h3 className="text-xl font-medium mt-6 mb-3">4.3 Réception des travaux</h3>
              <p>
                Pour les travaux de rénovation, une réception contradictoire sera effectuée en présence 
                du Client. Les éventuelles réserves devront être formulées par écrit. L'absence de réserve 
                vaut acceptation des travaux.
              </p>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl font-semibold mb-4">Article 5 - Obligations du Client</h2>
              <p>Le Client s'engage à :</p>
              <ul>
                <li>Fournir des informations exactes et complètes lors de la demande de devis</li>
                <li>Assurer l'accès aux locaux dans des conditions de sécurité normales</li>
                <li>Informer le Prestataire de toute particularité (matériaux fragiles, allergies, etc.)</li>
                <li>Protéger ou déplacer les objets de valeur avant l'intervention</li>
                <li>Régler les factures dans les délais convenus</li>
              </ul>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl font-semibold mb-4">Article 6 - Responsabilité et assurances</h2>
              <h3 className="text-xl font-medium mt-6 mb-3">6.1 Assurance responsabilité civile</h3>
              <p>
                Homely Solutions dispose d'une assurance responsabilité civile professionnelle couvrant 
                les dommages causés dans le cadre de ses prestations.
              </p>

              <h3 className="text-xl font-medium mt-6 mb-3">6.2 Limitation de responsabilité</h3>
              <p>
                La responsabilité de Homely Solutions est limitée aux dommages directs et prévisibles. 
                Elle ne saurait être engagée pour :
              </p>
              <ul>
                <li>Les dommages indirects ou immatériels</li>
                <li>Les dommages résultant d'informations erronées fournies par le Client</li>
                <li>Les dommages sur des matériaux fragiles non signalés</li>
                <li>Les cas de force majeure</li>
              </ul>

              <h3 className="text-xl font-medium mt-6 mb-3">6.3 Réclamations</h3>
              <p>
                Toute réclamation doit être formulée par écrit dans un délai de 8 jours suivant 
                la prestation ou la découverte du dommage.
              </p>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl font-semibold mb-4">Article 7 - Annulation et modification</h2>
              <h3 className="text-xl font-medium mt-6 mb-3">7.1 Annulation par le Client</h3>
              <ul>
                <li><strong>Plus de 48h avant</strong> l'intervention : annulation gratuite</li>
                <li><strong>Moins de 48h avant</strong> : 50% du montant du devis sera facturé</li>
                <li><strong>Le jour même</strong> : 100% du montant sera facturé</li>
              </ul>
              <p className="mt-4">
                Pour les travaux de rénovation, les conditions d'annulation sont définies au devis.
              </p>

              <h3 className="text-xl font-medium mt-6 mb-3">7.2 Annulation par le Prestataire</h3>
              <p>
                Homely Solutions se réserve le droit d'annuler une prestation en cas de force majeure 
                ou d'impossibilité d'exécution. Dans ce cas, les sommes versées seront intégralement remboursées.
              </p>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl font-semibold mb-4">Article 8 - Garanties</h2>
              <h3 className="text-xl font-medium mt-6 mb-3">8.1 Travaux de rénovation</h3>
              <p>
                Les travaux de rénovation bénéficient d'une garantie de parfait achèvement d'un an 
                et des garanties légales applicables en droit suisse.
              </p>

              <h3 className="text-xl font-medium mt-6 mb-3">8.2 Services de nettoyage et montage</h3>
              <p>
                En cas d'insatisfaction signalée dans les 24 heures, Homely Solutions s'engage à 
                repasser gratuitement pour corriger les éventuels manquements.
              </p>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl font-semibold mb-4">Article 9 - Protection des données</h2>
              <p>
                Les données personnelles collectées sont traitées conformément à notre 
                <a href="/politique-confidentialite" className="text-[var(--sage)] hover:underline"> Politique de Confidentialité</a> 
                et à la Loi fédérale sur la protection des données (LPD).
              </p>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl font-semibold mb-4">Article 10 - Propriété intellectuelle</h2>
              <p>
                Tous les éléments (devis, plans, études, visuels) produits par Homely Solutions 
                restent sa propriété intellectuelle et ne peuvent être réutilisés sans autorisation écrite.
              </p>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl font-semibold mb-4">Article 11 - Droit applicable et litiges</h2>
              <p>
                Les présentes CGV sont régies par le droit suisse. En cas de litige, les parties 
                s'efforceront de trouver une solution amiable. À défaut, les tribunaux du canton de Vaud 
                seront seuls compétents.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">Article 12 - Contact</h2>
              <p>
                Pour toute question concernant ces CGV, contactez-nous :
              </p>
              <div className="bg-gray-50 p-6 rounded-lg mt-4">
                <p><strong>Homely Solutions Sàrl</strong></p>
                <p>Rue Jean-André Venel 4</p>
                <p>1400 Yverdon-les-Bains, Suisse</p>
                <p className="mt-4">
                  <strong>Email :</strong> <a href="mailto:contact@homely-solutions.ch" className="text-[var(--sage)] hover:underline">contact@homely-solutions.ch</a>
                </p>
              </div>
            </section>
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};
